import React from 'react'
import Navbar from '../navbar/Navbar.js'
import Recovery from '../recovery/Recovery'
import Footer from '../footer/Footer'


const RecoveryPage = () => {
  return (
    <>
    <Navbar />
    <Recovery />
    <Footer />
    </>
  )
}

export default RecoveryPage
